import { render, staticRenderFns } from "./CMSEmailFormLogForm.vue?vue&type=template&id=56ffad34&"
import script from "./CMSEmailFormLogForm.vue?vue&type=script&lang=js&"
export * from "./CMSEmailFormLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports